export default class DragCursor {
	constructor() {
		const dragCursorSlides = document.querySelectorAll("[data-cursor]");

		let cursorFollower;
		let mouseX = 0;
		let mouseY = 0;
		let ballX = 0;
		let ballY = 0;
		let speed = 0.1;

		if (dragCursorSlides && !window.matchMedia("(max-width: 1200px)").matches) {
			cursorFollower = document.createElement("span");
			cursorFollower.classList.add("cursor-follower", "h5");
			document.body.appendChild(cursorFollower);

			function animateCursorFollower() {
				let distX = mouseX - ballX;
				let distY = mouseY - ballY;

				ballX = ballX + distX * speed;
				ballY = ballY + distY * speed;

				cursorFollower.style.left = ballX + "px";
				cursorFollower.style.top = ballY + "px";

				requestAnimationFrame(animateCursorFollower);
			}
			animateCursorFollower();

			dragCursorSlides.forEach((dSlide) => {
				dSlide.style.cursor = "grab";

				if (dSlide.id === "hero-video") {
					dSlide.style.cursor = "pointer";
				}

				dSlide.addEventListener("mouseout", (event) => {
					cursorFollower.style.opacity = "0";
				});

				dSlide.addEventListener("mouseover", (event) => {
					cursorFollower.innerHTML = dSlide.dataset.cursor;
				});

				dSlide.addEventListener("mousemove", (event) => {
					cursorFollower.innerHTML =
						cursorFollower.innerHTML === ""
							? dSlide.dataset.cursor
							: cursorFollower.innerHTML;
					cursorFollower.style.opacity = "1";
					mouseX = event.pageX;
					mouseY = event.pageY;
					if (["A"].includes(event.target.tagName)) {
						cursorFollower.style.opacity = "0";
					}
				});
			});
		}
	}
}
